/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
import React from "react";
export const SvgAlertError: React.FC<React.SVGAttributes<SVGElement>> = (
    props
) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill="currentColor"
                d="M15.171 3a2 2 0 011.414.586l3.828 3.828c.376.375.587.884.587 1.414v6.343a2 2 0 01-.586 1.414L16 21H8.828a2 2 0 01-1.414-.586l-3.828-3.828A2 2 0 013 15.172V8.828a2 2 0 01.586-1.414l3.828-3.828A2 2 0 018.828 3h6.343zm-3.172 12.25l-.11.006a1 1 0 10.227.001l-.117-.007zM12 6.75a.75.75 0 00-.75.75v5l.007.102a.75.75 0 001.493-.102v-5l-.007-.102A.75.75 0 0012 6.75z"
            />
            <path d="M0 0h24v24H0z" />
        </g>
    </svg>
);
